import React from 'react';
import {motion} from 'framer-motion';
import {Clock, Mail, MapPin, Phone, ShieldCheck} from 'lucide-react';
import {Map} from './Map';

export function ContactSection() {
    return (
        <section id="kontakt" className="w-full scroll-mt-20 py-20 md:py-28 px-5 bg-muted/50">
            <div className="max-w-6xl mx-auto">
                <motion.div
                    initial={{opacity: 0, y: 30}}
                    whileInView={{opacity: 1, y: 0}}
                    viewport={{once: true}}
                    transition={{duration: 0.6}}
                    className="text-center mb-16"
                >
                    <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-border bg-primary/5 text-xs md:text-sm font-semibold text-primary mb-4">
                        <ShieldCheck size={14}/> Montaż kamer Mielec i promień do 250 km - Skontaktuj się
                    </div>
                    <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
                        Porozmawiajmy o Twoim <span className="gradient-text">bezpieczeństwie</span>
                    </h2>
                    <p className="text-muted-foreground max-w-2xl mx-auto text-base md:text-lg">
                        Zadzwoń lub napisz. Siedziba w Mielcu przy ul. Wojska Polskiego 9/D211. 
                        <strong> Działamy w promieniu do 250 km od Mielca</strong> (Podkarpacie, Małopolska, Świętokrzyskie, Lubelskie). 
                        Bezpłatnie doradzimy, przeprowadzimy wizję lokalną i dobierzemy system monitoringu idealny dla Twojego domu lub firmy.
                    </p>
                </motion.div>

                <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
                    <motion.div
                        initial={{opacity: 0, y: 30}}
                        whileInView={{opacity: 1, y: 0}}
                        viewport={{once: true}}
                        transition={{duration: 0.6}}
                        className="rounded-2xl overflow-hidden border border-border/50 shadow-lg h-full"
                    >
                        <div className="aspect-[4/3] md:aspect-auto md:h-full md:min-h-[420px]">
                            <Map/>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{opacity: 0, y: 30}}
                        whileInView={{opacity: 1, y: 0}}
                        viewport={{once: true}}
                        transition={{duration: 0.6, delay: 0.2}}
                        className="space-y-6"
                    >
                        <div className="rounded-2xl border border-border/50 bg-card p-6">
                            <div className="flex items-center gap-3 mb-3">
                                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
                                    <MapPin size={20} className="text-primary"/>
                                </div>
                                <h3 className="font-bold text-lg text-foreground">Lokalizacja i obszar działania</h3>
                            </div>
                            <p className="text-muted-foreground mt-2 sm:mt-0 sm:ml-[52px]">
                                <strong className="text-foreground">Kamery Mielec - ONEXO</strong><br/>
                                ul. Wojska Polskiego 9/D211<br/>
                                39-300 Mielec, woj. podkarpackie
                            </p>
                        </div>

                        <div className="rounded-2xl border border-border/50 bg-card p-6">
                            <div className="flex items-center gap-3 mb-3">
                                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
                                    <Phone size={20} className="text-primary"/>
                                </div>
                                <h3 className="font-bold text-lg text-foreground">Bezpośredni kontakt</h3>
                            </div>
                            <div className="grid sm:grid-cols-2 gap-4 px-1 pt-1">
                                <div className="space-y-1 bg-primary/10 dark:bg-primary/20 rounded-xl p-4 border border-primary/20">
                                    <p className="text-foreground text-sm font-bold">Adrian Sokół</p>
                                    <p className="text-xs text-muted-foreground mb-2">Doradca techniczny i montaż</p>
                                    <div className="flex flex-col gap-2">
                                        <a
                                            href="tel:+48664896662"
                                            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background/80 text-primary text-sm font-semibold hover:bg-background transition-colors"
                                        >
                                            <Phone size={14}/>
                                            +48 664 896 662
                                        </a>
                                        <a
                                            href="mailto:kontakt@kamerymielec.pl"
                                            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background/80 text-primary text-xs font-medium hover:bg-background transition-colors"
                                        >
                                            <Mail size={13}/>
                                            kontakt@kamerymielec.pl
                                        </a>
                                    </div>
                                </div>
                                <div className="space-y-1 bg-muted/60 rounded-xl p-4 border border-border">
                                    <p className="text-foreground text-sm font-bold">Julian Zieliński</p>
                                    <p className="text-xs text-muted-foreground mb-2">Wsparcie IT i wyceny</p>
                                    <div className="flex flex-col gap-2">
                                        <a
                                            href="tel:+48516856392"
                                            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background/80 text-foreground text-sm font-semibold hover:bg-background transition-colors"
                                        >
                                            <Phone size={14}/>
                                            +48 516 856 392
                                        </a>
                                        <a
                                            href="mailto:j.zielinski@onexo.pl"
                                            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background/80 text-muted-foreground text-xs font-medium hover:bg-background transition-colors"
                                        >
                                            <Mail size={13}/>
                                            j.zielinski@onexo.pl
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="rounded-2xl border border-border/50 bg-card p-6">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
                                    <Clock size={20} className="text-primary"/>
                                </div>
                                <h3 className="font-bold text-lg text-foreground">Godziny kontaktu i montażu</h3>
                            </div>
                            <div className="mt-2 sm:mt-0 sm:ml-[52px] space-y-2.5">
                                <div className="flex items-center justify-between">
                                    <span className="font-semibold text-sm text-foreground/80">Poniedziałek - Piątek</span>
                                    <span className="px-3 py-1 rounded-full bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 text-sm font-semibold">
                                        7:00 - 18:00
                                    </span>
                                </div>
                                <div className="flex items-center justify-between">
                                    <span className="font-semibold text-sm text-foreground/80">Sobota (montaże po uzgodnieniu)</span>
                                    <span className="px-3 py-1 rounded-full bg-amber-500/10 text-amber-600 dark:text-amber-400 text-sm font-semibold">
                                        8:00 - 14:00
                                    </span>
                                </div>
                                <div className="flex items-center justify-between">
                                    <span className="font-semibold text-sm text-foreground/80">Niedziela</span>
                                    <span className="px-3 py-1 rounded-full bg-red-500/10 text-red-600 dark:text-red-400 text-sm font-semibold">
                                        Nieczynne
                                    </span>
                                </div>
                            </div>
                        </div>

                        <a
                            href="tel:+48664896662"
                            className="flex items-center justify-center gap-2 w-full py-4 rounded-2xl bg-primary text-white font-semibold text-lg hover:brightness-110 transition-all shadow-lg shadow-primary/20 active:scale-[0.99]"
                        >
                            <Phone size={20}/>
                            Zadzwoń do nas: +48 664 896 662
                        </a>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
